"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDictateButton = require("react-dictate-button");

var _react = _interopRequireDefault(require("react"));

var _botframeworkWebchatCore = require("botframework-webchat-core");

var _connectToWebChat = _interopRequireDefault(require("./connectToWebChat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var _Constants$DictateSta = _botframeworkWebchatCore.Constants.DictateState,
    DICTATING = _Constants$DictateSta.DICTATING,
    IDLE = _Constants$DictateSta.IDLE,
    STARTING = _Constants$DictateSta.STARTING;

var Dictation =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dictation, _React$Component);

  function Dictation(props) {
    var _this;

    _classCallCheck(this, Dictation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dictation).call(this, props));
    _this.handleDictate = _this.handleDictate.bind(_assertThisInitialized(_this));
    _this.handleDictating = _this.handleDictating.bind(_assertThisInitialized(_this));
    _this.handleError = _this.handleError.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Dictation, [{
    key: "handleDictate",
    value: function handleDictate(_ref) {
      var _ref$result = _ref.result;
      _ref$result = _ref$result === void 0 ? {} : _ref$result;
      var transcript = _ref$result.transcript;
      var props = this.props;
      props.setDictateInterims([]);
      props.setDictateState(IDLE);
      props.stopDictate();

      if (transcript) {
        props.setSendBox(transcript);
        props.submitSendBox('speech');
        props.startSpeakingActivity();
      }
    }
  }, {
    key: "handleDictating",
    value: function handleDictating(_ref2) {
      var _ref2$results = _ref2.results,
          results = _ref2$results === void 0 ? [] : _ref2$results;
      var props = this.props;
      var interims = results.map(function (_ref3) {
        var transcript = _ref3.transcript;
        return transcript;
      });
      props.setDictateInterims(interims);
      props.setDictateState(DICTATING); // This is for two purposes:
      // 1. Set send box will also trigger send typing
      // 2. If the user cancelled out, the interim result will be in the send box so the user can update it before send

      props.setSendBox(interims.join(' '));
    }
  }, {
    key: "handleError",
    value: function handleError(event) {
      var props = this.props;
      props.setDictateState(IDLE);
      props.stopDictate();
      props.onError && props.onError(event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dictateState = _this$props.dictateState,
          disabled = _this$props.disabled,
          language = _this$props.language,
          webSpeechPonyfill = _this$props.webSpeechPonyfill,
          handleDictate = this.handleDictate,
          handleDictating = this.handleDictating,
          handleError = this.handleError;

      var _ref4 = webSpeechPonyfill || {},
          SpeechGrammarList = _ref4.SpeechGrammarList,
          SpeechRecognition = _ref4.SpeechRecognition;

      return _react.default.createElement(_reactDictateButton.Composer, {
        lang: language,
        onDictate: handleDictate,
        onError: handleError,
        onProgress: handleDictating,
        speechRecognition: SpeechRecognition,
        speechGrammarList: SpeechGrammarList,
        started: !disabled && (dictateState === STARTING || dictateState === DICTATING)
      });
    }
  }]);

  return Dictation;
}(_react.default.Component);

var _default = (0, _connectToWebChat.default)(function (_ref5) {
  var dictateState = _ref5.dictateState,
      disabled = _ref5.disabled,
      language = _ref5.language,
      setDictateInterims = _ref5.setDictateInterims,
      setDictateState = _ref5.setDictateState,
      setSendBox = _ref5.setSendBox,
      startSpeakingActivity = _ref5.startSpeakingActivity,
      stopDictate = _ref5.stopDictate,
      submitSendBox = _ref5.submitSendBox,
      webSpeechPonyfill = _ref5.webSpeechPonyfill;
  return {
    dictateState: dictateState,
    disabled: disabled,
    language: language,
    setDictateInterims: setDictateInterims,
    setDictateState: setDictateState,
    setSendBox: setSendBox,
    startSpeakingActivity: startSpeakingActivity,
    stopDictate: stopDictate,
    submitSendBox: submitSendBox,
    webSpeechPonyfill: webSpeechPonyfill
  };
})(Dictation);

exports.default = _default;